import { System } from '../../_snowpack/pkg/eaciest.js';
import { invert_phase } from '../../game/unit-phase.js';
import { createSoundCommand } from '../../proto/audio.js';
import { rand } from '../../utils/random.js';
import { not } from '../../utils/selectors.js';
import { MagicMark } from './magic.js';

export class PhaseSwitchSystem extends System {
  constructor () {
    super(['phase', not(MagicMark)]);
  }
  
  update () {
    const now = Date.now();
    for (const entity of this.getEntities()) {
      if (!entity.next_switch) {
        entity.next_switch = now + rand(3500, 17000);
      }

      if (now - entity.next_switch >= 0) {
        entity.next_switch = now + rand(3500, 17000);
        entity.phase = invert_phase(entity.phase);
        // this.getEngine().addEntity(createSoundCommand('switch'));
        delete entity.targetPos;
      }
    }
  }
}
